export default class ReportService {
  constructor (Restangular) {
    'ngInject'

    this.reporting = Restangular.all('/reporting')
    this.info = Restangular.all('/reporting/campaign/info')
  }
}
